const trackingUtils = require('../modules/utils/tracking.utils');
const userAccountError = require('../modules/users/user_account_error');
const xsellFindBookingFactory = require('components/cross_selling/find_booking/js/main');
const frequentPassengersFactory = require('components/user_area/frequent_passengers_manager/js/main');
const downloadAppBannerFactory = require('components/app_download/download_app_banner/js/main');
const createWidgetLoader = require('components-framework/widget/create_widget_loader');

Odigeo.Router.handlers.frequentpassengers = function(passenger) {
    const pageName = 'frequentpassengers';
    const $page = $('#page');

    const widgetLoader = createWidgetLoader({
        xsellFindBooking: ['my-trips-with-find-booking', xsellFindBookingFactory],
        frequentPassengers: ['frequent-passengers-manager', frequentPassengersFactory],
        downloadAppBanner: ['download-app-banner', downloadAppBannerFactory],
    });

    $page.removeClass().addClass(pageName);

    Odigeo.Router.eventController = $.extend(
        Odigeo.Router.eventController,
        Odigeo.Router.handlers.globalEventController,
        Odigeo.Router.handlers.userEventController,
    );
    Odigeo.Router.eventController = $.extend(true, Odigeo.Router.eventController, {
        globalEvents: {
            'global:onGetDataError': 'onGetDataError',
        },
        viewEvents: {
            'users-manager:getAccountInfoOk': 'onGetAccountInfo',
            'users-manager:getAccountInfoWithError': 'onGetDataError',
            'users-manager:getAccountInfoError': 'onGetDataError',
            'users-manager:logOutOk': 'onGoToHomePage',
            'users-manager:updateAccountInfoOk': 'onFrequentPassengersRequest',
            'users-manager:updateAccountInfoWithError': 'onFrequentPassengersRequest',
            'users-manager:updateAccountInfoError': 'onFrequentPassengersRequest',
            'frequent-passengers-manager:changePageTitle': 'onChangePageTitle',
            'frequent-passengers-manager:submitUserRequest': 'onUserManagerRequest',
        },
        eventHandlers: {
            onGetDataError(data) {
                userAccountError.processError(data);
            },

            onGoToHomePage() {
                Odigeo.Utils.goToApplicationHome();
            },

            onFrequentPassengersRequest(data) {
                _frequentPassengersRequest(data);
            },

            onUserManagerRequest(data, isControllerAction) {
                _userManagerRequest(data, isControllerAction);
            },

            onChangePageTitle(page) {
                _changePageTitle(page);
            },

            onGetAccountInfo(data) {
                $('#myInfoUserName').text(data.displayName ? data.displayName : '');
                _frequentPassengersRequest(data);
            },
        },
    });
    Odigeo.Router.eventController.execute();

    const $personalAreaMenu = $('#personal_area_menu');
    const menu = Odigeo.UIElements.menu.enhanceMenu($personalAreaMenu);
    const $freqPassEditTitle = $('.freq_pass_edit_title');
    const $freqPassMainTitle = $('.freq_pass_main_title');
    const $freqPassNotificationError = $('.freq_pass_notification_error');

    const _frequentPassengersRequest = (data) => {
        widgetLoader.get('frequentPassengers').execute(data.action, data);
        widgetLoader.get('downloadAppBanner').execute('trackEventCategory', 'my_area_pax');
    };

    const _userManagerRequest = (data, isControllerAction) => {
        const method = isControllerAction ? data.action : 'submitUserRequest';
        const requestData = isControllerAction ? data.data : data;
        Odigeo.requireWidget('users-manager', 'usersmanager', function(usersmanager) {
            usersmanager.execute(method, requestData);
        });
    };

    const _changePageTitle = (page) => {
        $personalAreaMenu.data('track-action', 'sidebar').data('track-category', 'my_area_pax');
        $freqPassEditTitle.toggleClass('hidden', (page !== 'edit' && page !== 'new'));
        $freqPassMainTitle.toggleClass('hidden', (page === 'edit' || page === 'new'));
    };

    const _cleanNotificationErrors = () => {
        $freqPassNotificationError.toggleClass('hidden', true);
    };

    _cleanNotificationErrors();
    _frequentPassengersRequest({action: 'setUserID', userID: passenger});
    _changePageTitle('main');
    _userManagerRequest({data: '', action: 'getAccountInfo'});

    if (menu) {
        menu.trigger('changeSelectedMenu', $page.attr('class'));
        widgetLoader.get('xsellFindBooking').execute('emptyFindBookings');
    }

    // Analytics: virtual page tracking
    trackingUtils.trackPage('account/frequent_travelers', {
        funnel: false,
    });
};
